import React from 'react';
import moment from 'moment';

const HeroSectionTable = ({ heroSectionList, handleItemClick }) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="table-responsive">
          <h5 className="card-title fw-bold mb-3">Hero Section Management</h5>
          <table className="table table-striped table-hover">
            <thead className="table-light">
              <tr>
                <th scope="col">Index</th>
                <th scope="col">Type</th>
                <th scope="col">Name / Slug</th>
                <th scope="col">Updated At</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {heroSectionList.map((item) => (
                <tr key={item.index}>
                  <td>{item.index}</td>
                  <td>{item.type}</td>
                  {item.type === "survey" ? (
                    <td>
                      {item?.surveyId?.title ? item?.surveyId?.title : "N/A"}
                    </td>
                  ) : (
                    <td>
                      {item?.articleSlug ? item?.articleSlug?.post_title : "N/A"}
                    </td>
                  )}
                  <td>{moment(item?.updatedAt).format("DD-MM-YYYY")}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-warning px-4"
                      onClick={() => handleItemClick(item, "hero-section-edit")}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HeroSectionTable; 